import { I18nUtils } from '../../../i18n/I18nUtils';

export class ContractorFileFormValidator {

    static validate(values) {
        const {
            name,
            file
        } = values;

        const errors = {};
        const emptyFieldError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

        if (!name) errors.name = emptyFieldError;
        if (!file || file.length === 0) errors.file = emptyFieldError;

        return errors;
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/form/ContractorFileFormValidator.js